const DOCUMENT_RULES = {
  123: {
    mask: "##########",
    placeholder: "Ingresa tu cédula",
    sanitize: (value) => String(value || "").replace(/\D/g, ""),
    pattern: /^\d{5,10}$/,
    invalidMessage: "Informe una Cédula colombiana válida con 5 a 10 dígitos.",
  },
  961: {
    mask: "########-X",
    placeholder: "Ingresa tu DNI",
    sanitize: (value) => {
      const raw = String(value || "").toUpperCase().replace(/[^0-9A-Z]/g, "");
      const body = raw.slice(0, 8).replace(/\D/g, "");
      const verifier = raw.slice(8, 9).replace(/[^0-9A-Z]/g, "");
      return `${body}${verifier ? `-${verifier}` : ""}`;
    },
    pattern: /^\d{8}(-?[0-9A-K])?$/,
    invalidMessage: "Informe un DNI peruano válido con 8 dígitos o con dígito verificador.",
  },
};

export function getDocumentRule(questionId) {
  return DOCUMENT_RULES[Number(questionId)] || null;
}

export function sanitizeDocumentValue(value, questionId) {
  const rule = getDocumentRule(questionId);
  if (!rule) return value;
  return rule.sanitize(value);
}

export function isDocumentAnswerValid(value, questionId) {
  const rule = getDocumentRule(questionId);
  if (!rule) return true;
  return rule.pattern.test(sanitizeDocumentValue(value, questionId));
}

export function getDocumentErrorMessage(questionId) {
  const rule = getDocumentRule(questionId);
  return rule ? rule.invalidMessage : "";
}
